import cn from 'classnames'
import styles from './Headline.module.scss'

export function Headline({
  className = '',
  tag = 'h1',
  color = 'black',
  weight = 400,
  style = undefined,
  children
}) {
  const CustomTag = tag

  const classesItem = cn({
    [styles['headline_color_' + color]]: color,
    [styles['headline_weight_' + weight]]: weight
  })

  return (
    <div className={`headline ${className}`} style={style}>
      <CustomTag className={classesItem}>{ children }</CustomTag>
    </div>
  )
}
